/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconRefresh16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconRefresh16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M8 .751A.75.75 0 0 1 9.164.126l3.391 2.244a.75.75 0 0 1 0 1.251L9.164 5.865A.75.75 0 0 1 8 5.24V3.996a5 5 0 1 0 5 5 1 1 0 1 1 2 0 7 7 0 1 1-7-7V.75Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconRefresh24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconRefresh24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M12 2.451a.75.75 0 0 1 1.177-.616l4.432 3.068a.75.75 0 0 1 0 1.233l-4.432 3.069A.75.75 0 0 1 12 8.588V6.27a7 7 0 1 0 7 7 1 1 0 1 1 2 0 9 9 0 1 1-9-9V2.45Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconRefresh = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconRefresh(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconRefresh16 {...iconProps} />;
        case '24':
            return <IconRefresh24 {...iconProps} />;
        default:
            return <IconRefresh24 {...iconProps} />;
    }
});
